module.exports = __webpack_public_path__ + "static/media/derby-logo.11862f84.png";